module.exports = __webpack_public_path__ + "static/media/seller_portrait_put_2x.4b15e2b1.png";